import type { ResultDetailsQuery } from '#api/shared/@types/generated/backend/graphql-schema-types'

export type ResultDetailsPrizeCategoryPrize = ResultDetailsPrizeCategory['prizes'][0]
type ResultDetailsPrizeCategory = ResultDetailsQuery['drawDetail']['prizeCategories'][0]

// JUST QUICK FIX FOR SF-4902, should be fixed after SF-4904
const EXCLUDE_FROM_OPTIONAL_ADDONS = ['betType', 'doublePlay', 'extrahit', 'plus']

export const useResultDetails = async () => {
  const { params } = useRoute()

  const showWithAddOn = useState(() => false)

  const id = params.slug ? String(params.slug) : null
  const licensedTerritory = id?.split('_', 2).join('-')
  const lotteryId = getLotteryIdInCorrectCase(id?.split('_')[2])

  if (!licensedTerritory || !lotteryId)
    throw new Error('useResultDetails composable can only be used in valid result details routes')

  const response = await useResultDetailsLazyQuery({
    id,
  }).load()

  const result = computed(() => (response ? response.drawDetail : null))

  const addOns = computed(() => [
    ...(currentConfig.value?.addOns ?? []),
    ...(currentConfig.value?.afterPurchaseAddOns ?? []),
  ])
  const currentConfig = computed(() => result.value?.lotteryConfig.currentConfig ?? null)
  const drawDate = computed(() => result.value?.drawDate ?? null)
  const drawnNumbers = computed(() => result.value?.drawnNumbers ?? [])
  const hasCombinedTierTable = computed(() => !!currentConfig.value?.combinedTierTable)
  const hasOptionalAddOn = computed(() => !!optionalAddOn.value)
  const isEvaluated = computed(() => !!prizeCategories.value.length)
  const isWinnersTabVisible = computed(() => !!currentConfig.value?.hasNumberOfWinners)
  const optionalAddOn = computed(
    () =>
      addOns.value
        .filter(({ name }) => !EXCLUDE_FROM_OPTIONAL_ADDONS.includes(name))
        .find(({ mandatory }) => !mandatory) ?? null,
  )
  const prizeCategories = computed(() => result.value?.prizeCategories ?? [])
  const prizeTierCategories = computed(() => currentConfig.value?.prizeTierCategories ?? [])
  const timeOfDay = computed(() => {
    if (!result.value?.hasMultipleDrawsOnDay) return null
    return result.value?.label
  })
  const timeZone = computed(() => result.value?.lotteryConfig.timeZone ?? null)

  return {
    addOns,
    drawDate,
    drawnNumbers,
    hasCombinedTierTable,
    hasOptionalAddOn,
    isEvaluated,
    isWinnersTabVisible,
    licensedTerritory,
    lotteryId,
    optionalAddOn,
    prizeCategories,
    prizeTierCategories,
    showWithAddOn,
    timeOfDay,
    timeZone,
  }
}
